import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "shop-transfer-request"
    }}>{`Shop Transfer Request`}</h2>
    <p>{`The super admin will be able to navigate to the shop transfer request list from the Dashboard. From this module, the super admin will be able to see all the shop transfer request list and approve or disapprove them accordingly. `}</p>
    <p>{`SuperAdmin approval is required for the shop transfer request. If not, the shop transfer process will not be successful. The main objective of the super admin shop transfer request approval is for verification of the following conditions: `}</p>
    <ul>
      <li parentName="ul">{`The "Shop Transfer To" owner profile is all set.`}</li>
      <li parentName="ul">{`There should be no pending orders or refunds of the current shop owner. `}</li>
      <li parentName="ul">{`The remaining available balance for the current shop owner should be zero (0). `}</li>
    </ul>
    <p><img alt="shop-maintenance" src={require("../images/shop_transfer/transfer_request1.png")} /></p>
    <p>{`From the "Shop Ownership Transfer Request List" the super admin will be able to see the ownership transfer request by "ID", "Request tracker", "Message", "Request created by", "Shop transfer to", "Transfer status", "Details" and "Actions". `}</p>
    <p><img alt="shop-maintenance" src={require("../images/shop_transfer/transfer_request2.png")} /></p>
    <p>{`The users are able to serach the ownership transfer request by "Request tracker" from the search bar. `}</p>
    <p><img alt="shop-maintenance" src={require("../images/shop_transfer/transfer_request3.png")} /></p>
    <p>{`By clicking on `}<inlineCode parentName="p">{`view`}</inlineCode>{` details, the super admin will be able to navigate to shop request details module. There the super admin will be able to see the Transfer request details, shop details and many more. From the change status drop down list the super admin will be able to change the status of the shop by selecting it from the "Shop Transfer Status" dropdown. `}</p>
    <p>{`The change status button will remain diable for the following senerios:`}</p>
    <ul>
      <li parentName="ul">{`The shop transfer procedure won't be successful if the store is still processing orders since all order statuses need to be completed before the shop is transferred. `}</li>
      <li parentName="ul">{`The shop transfer request will not be approved if the business has any outstanding balances that need to be transferred to the store owner. `}</li>
      <li parentName="ul">{`The store transfer will not be successful if there is a refund order to process. `}</li>
    </ul>
    <p><img alt="shop-maintenance" src={require("../images/shop_transfer/transfer_request5.png")} /></p>
    <p>{`The super admin will be able to communicate with the current store owner directly by clicking on the message icon. Once the transfer request gets completed, the super admin and the current shop owner won't be able to commucicate by message by clicking on the message icon. `}</p>
    <p><img alt="shop-maintenance" src={require("../images/shop_transfer/transfer_request6.png")} /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      